/**
 *  @class
 *  @function TextRotator
 */

if (!customElements.get('text-rotator')) {
  class TextRotator extends HTMLElement {
    constructor() {
      super();

      this.words = this.querySelectorAll('.text-rotator--word');
      this.wordsContainer = this.querySelector('.text-rotator--words');
      this.currentIndex = 0;
      this.wordWidths = [];
      this.isAnimating = false;
      this.animations_enabled = document.body.classList.contains('animations-true') && typeof gsap !== 'undefined';
    }
    connectedCallback() {
      if (this.words.length < 2) return;

      this.duration = parseInt(this.dataset.duration, 10) || 3000;

      document.fonts.ready.then(() => {
        this.measureWords();
        this.init();
      });
    }
    disconnectedCallback() {
      if (this._timeout) clearTimeout(this._timeout);
    }
    measureWords() {
      let clone = this.wordsContainer.cloneNode(true),
        heading = this.querySelector('.text-rotator--heading'),
        cloneWords = clone.querySelectorAll('.text-rotator--word');

      clone.style.cssText = 'position:absolute;visibility:hidden;left:-9999px;top:-9999px;height:auto;width:auto;overflow:visible;pointer-events:none;';
      cloneWords.forEach((w) => {
        w.style.cssText = 'position:static;display:inline-block;opacity:1;transform:none;';
      });

      heading.appendChild(clone);
      cloneWords.forEach((w, i) => {
        this.wordWidths[i] = Math.ceil(w.offsetWidth) + 2;
      });
      clone.remove();

      let lineHeight = Math.ceil(parseFloat(getComputedStyle(this.wordsContainer).fontSize) * 1.2);
      this.wordsContainer.style.height = lineHeight + 'px';
      this.wordsContainer.style.width = this.wordWidths[0] + 'px';
    }
    init() {
      if (this.animations_enabled) {
        this.initGSAP();
      } else {
        this.initBasic();
      }
    }
    initGSAP() {
      // Position all words below, invisible
      this.words.forEach((word) => {
        gsap.set(word, { y: 25, autoAlpha: 0, overwrite: true });
      });

      // Show first word
      gsap.set(this.words[0], { y: 0, autoAlpha: 1, overwrite: true });

      this.scheduleNext();
    }
    scheduleNext() {
      this._timeout = setTimeout(() => {
        this.rotateGSAP();
      }, this.duration);
    }
    rotateGSAP() {
      if (this.isAnimating) return;
      this.isAnimating = true;

      let current = this.words[this.currentIndex],
        nextIndex = (this.currentIndex + 1) % this.words.length,
        next = this.words[nextIndex],
        section = this;

      // Animate container width
      gsap.to(this.wordsContainer, {
        duration: 0.6,
        width: this.wordWidths[nextIndex],
        ease: 'power3.inOut',
        overwrite: true
      });

      // Current word exits upward
      gsap.to(current, {
        duration: 0.5,
        y: -25,
        autoAlpha: 0,
        scale: 0.96,
        ease: 'power2.in',
        overwrite: true,
        onComplete: function() {
          gsap.set(current, { y: 25, scale: 1 });
        }
      });

      // Next word enters from below (after slight delay)
      gsap.set(next, { y: 20, scale: 1.03 });
      gsap.to(next, {
        duration: 0.55,
        delay: 0.15,
        y: 0,
        autoAlpha: 1,
        scale: 1,
        ease: 'power2.out',
        overwrite: true,
        onComplete: function() {
          section.isAnimating = false;
          section.currentIndex = nextIndex;
          section.scheduleNext();
        }
      });
    }
    initBasic() {
      this.words[0].style.opacity = '1';
      this.words[0].style.transform = 'translateY(0)';
      this.scheduleNextBasic();
    }
    scheduleNextBasic() {
      this._timeout = setTimeout(() => {
        this.rotateBasic();
      }, this.duration);
    }
    rotateBasic() {
      let current = this.words[this.currentIndex];
      current.style.opacity = '0';

      this.currentIndex = (this.currentIndex + 1) % this.words.length;
      let next = this.words[this.currentIndex];
      this.wordsContainer.style.width = this.wordWidths[this.currentIndex] + 'px';

      setTimeout(() => {
        next.style.opacity = '1';
        next.style.transform = 'translateY(0)';
        this.scheduleNextBasic();
      }, 100);
    }
  }
  customElements.define('text-rotator', TextRotator);
}
